import ReactDOM from "react-dom";
import React from "react";
import SchoolMap from "./SchoolMap/index";

const init = (api) => {
  const element = document.querySelector("[data-school-map]");

  if (!element) {
    return;
  }

  ReactDOM.render(<SchoolMap api={api} />, element);
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/schoolMap.js